/**
 * `/setup` — la rotta storica del Setup wizard, che creava un tenant da zero.
 *
 * Dal 10-09-2026 la creazione è il primo tratto dell'Onboarding guidato (`/onboarding?nuova=1`):
 * stesso design, stessi passi, e alla fine si continua con la configurazione del tenant appena nato
 * invece di tornare alla Home. La rotta resta per i segnalibri e per i documenti che la citano.
 */
import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/setup')({
  component: () => <Navigate to="/onboarding" search={{ new: true }} replace />,
});
